<div class="db-confirm-downgrade-agreement">
  <ng-container>
    <h1>{{ 'text_rediscover10WebStartFreshWithNewFeatures' | dbText }}</h1>
    <p class="mt4" [innerHTML]="'text_exploreTheNewFeaturesAndPossibilitiesOurPlatformOffers' | dbText"></p>
    <div class="db-confirm-downgrade-agreement-buttons mt30">

      <button class="ds-btn-black" [ngClass]="{'db-button_disabled' : loading}" (click)="downgradeAgreement()">
        <span *ngIf="!loading">{{ 'text_confirmAndContinue' | dbText }}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </button>
    </div>
  </ng-container>

</div>
